module.exports = __webpack_public_path__ + "static/media/x-dark.d08cca75.svg";